import { loadStripe } from '@stripe/stripe-js';

// For development, use a hardcoded test key if the environment variable isn't set
// In production, make sure REACT_APP_STRIPE_PUBLISHABLE_KEY is set in your environment
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Initialize Stripe with the publishable key
export const getStripeInstance = async () => {
   try {
      const stripe = await loadStripe(STRIPE_PUBLISHABLE_KEY || '');
      if (!stripe) throw new Error('Failed to initialize Stripe');
      return stripe;
   } catch (error) {
      console.error('Error initializing Stripe:', error);
      throw error;
   }
};

// Example price IDs for different subscription plans
export const SUBSCRIPTION_PRICES = {
  yearly: 'price_yearly_subscription',
  monthly: 'price_monthly_subscription',
  organization: 'price_organization_subscription'
};

// TEMPORARY SOLUTION: Create a Stripe checkout session directly (for testing only)
// In production, this should be done in a secure backend/Cloud Function
export const createCheckoutSession = async (options: {
   priceId: string;
   successUrl: string;
   cancelUrl: string;
   customerEmail?: string;
}) => {
   try {
      // This is a dummy implementation that simulates a successful checkout session
      // In a real implementation, you would make a server-side API call to Stripe

      // For testing: redirect to the success URL directly
      window.location.href = options.successUrl.replace(
         '{CHECKOUT_SESSION_ID}',
         'test_session_' + Date.now()
      );

      return { id: 'test_session_' + Date.now() };
   } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
   }
};

// TEMPORARY SOLUTION: Create a Stripe portal session directly (for testing only)
// In production, this should be done in a secure backend/Cloud Function
export const createPortalSession = async (options: { returnUrl: string }) => {
   try {
      // This is a dummy implementation that simulates a successful portal session
      // In a real implementation, you would make a server-side API call to Stripe

      // For testing: redirect to the return URL directly
      window.location.href = options.returnUrl;

      return { url: options.returnUrl };
   } catch (error) {
      console.error('Error creating portal session:', error);
      throw error;
   }
}; 